export default async function Resend2FAApi(userId) {
  let res = "";
  try {
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify({ userId }),
    };

    await fetch(
      `${process.env.REACT_APP_API_URL}v1/auth/resend-2fa`,
      requestOptions
    )
      .then((response) => response.json())
      .then((response) => {
        res = response;
      })
      .catch((error) => {
        console.error("Error resending 2FA: ", error);
        res = error;
      });
  } catch (error) {
    console.error(error);
    res = error;
  }

  return res;
}
